import { QueryConfig } from "store/utils/query-config";

export const usersDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"],
  },
};
